export const cilAvTimer = ["24 24","<path d='M11.25 18h1.5v1.5h-1.5v-1.5z'></path><path d='M4.5 11.25h1.5v1.5h-1.5v-1.5z'></path><path d='M18 11.25h1.5v1.5h-1.5v-1.5z'></path><path d='M19.425 4.575c-1.723-1.733-4.052-2.863-6.641-3.047l-0.033-0.002v-0.027h-1.5v4.5h1.5v-2.969c4.613 0.383 8.25 4.259 8.25 8.969 0 4.963-4.037 9-9 9s-9-4.037-9-9c0-0.002 0-0.005 0-0.007 0-2.487 1.011-4.738 2.644-6.364l0-0 5.418 6.838 1.176-0.932-6.397-8.073-0.591 0.496c-2.299 1.939-3.75 4.821-3.75 8.043 0 5.799 4.701 10.5 10.5 10.5s10.5-4.701 10.5-10.5c0-2.899-1.175-5.524-3.075-7.424v0z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-av-timer.js
// module id = null
// module chunks = 